

























































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { TsManagerRatingTypeEnum, TsRateeUser, TsUserDto } from '@/interfaces'
import dayjs from 'dayjs'
import { Getter } from 'vuex-class'

@Component({
  name: 'RaterRateeCard'
})
export default class RaterRateeCard extends Vue {
  @Prop({ required: true })
  raterRatee!: TsRateeUser

  @Prop({ required: true })
  tsSurveyId!: number

  @Getter('ts/getUsers')
  tsUserInfo!: TsUserDto

  @Getter('ts/hasRoleRater')
  hasRoleRater!: boolean

  @Getter('ts/hasRoleManager')
  hasRoleManager!: boolean

  get formattedExpiryDate (): string {
    return (this.raterRatee.isLive && this.raterRatee.expiryTime)
      ? dayjs(this.raterRatee.expiryTime.toString()).format('DD/MM/YYYY')
      : ''
  }

  get formattedDate (): string {
    return (this.raterRatee.expiryTime)
      ? dayjs(this.raterRatee.expiryTime.toString()).format('DD/MM/YYYY')
      : dayjs(new Date().toString()).format('DD/MM/YYYY')
  }

  reviewRatee (): void {
    this.$router.push({
      name: 'survey.ts.user.ratee',
      params: {
        tsSurveyId: this.tsSurveyId.toString(),
        tsRaterRateeId: this.raterRatee.id.toString()
      }
    })
  }

  setup (id: number): void {
    this.$router.push({
      name: 'survey.ts.manager.ratee',
      params: {
        tsSurveyId: this.tsSurveyId.toString(),
        tsManagerRateeId: id.toString()
      }
    })
  }

  rating (type: TsManagerRatingTypeEnum) : void {
    this.$router.push({
      name: 'survey.ts.manager.rating',
      params: {
        tsSurveyId: this.tsSurveyId.toString(),
        tsRaterRateeId: this.raterRatee.id.toString(),
        type
      }
    })
  }

  results (id: number) {
    this.$router.push({
      name: 'survey.ts.user.results',
      params: {
        tsSurveyId: this.tsSurveyId.toString(),
        tsRaterRateeId: id.toString()
      }
    })
  }
}
